import VirtualTable from "../../custom/VirtualTable";
import useData from '../../../views/managers/TempControlManager/useData';
import { useAppContext } from "../../../context";
import { useEffect, useRef, useState } from "react";
import { IRack, ITempControllSetting } from "../../../globals/interfaces";
import ActionIcon from "../../custom/ActionIcon";
import { fileDownload } from "../../../utils";
import moment from "moment";
import _ from "lodash";
import apiClient from "../../../apiClient";

type TempControlRackData = ITempControllSetting & IRack;

export default function Coolers() {

    const { user, setLoading } = useAppContext();
    const [data, setData] = useState<Array<TempControlRackData>>([]);
    const tableRef = useRef();

    useEffect(() => {
        const getData = async () => {
            setLoading(true);
            try {
                const res = await apiClient.get(`/tempControl/data-awbs-eos/${user.s_unit}`);
                const data: Array<ITempControllSetting> = res.data;
                const useData: Array<TempControlRackData> = [];

                for (const item of data) {
                    const { awbs } = item;
                    awbs?.map((awb) => useData.push({ ...item, ...awb }));
                }
                setData(useData);
            } catch (err) {
                alert(err);
            }
            setLoading(false);
        }
        getData();
    }, [user.s_unit]);

    const sortedData = data?.sort((a, b) => a.location.localeCompare(b.location));

    const exportData = () => {
        if (!tableRef.current) return;
        // @ts-ignore
        const raw = tableRef.current.getResolvedState().sortedData;
        const copy = _.cloneDeep(raw);
        const data = copy.map((record: any) => record._original);
        const deleteArray = ['tempControlled', 'uuid', 'currentTemp', 'awbs', 'index'];
        
        const formatted = data.map((item: TempControlRackData) => {
            // @ts-ignore
            deleteArray.map(key => delete item[key]);
            const formatted = {
                'location': item.location,
                'setting': item.setting,
                'current temp.': item.tempVal,
                'date': item.tempDate,
                'mawb': item.s_mawb,
                'hawb': item.s_hawb,
                'pieces': item.i_pieces,
                'destination': item.s_destination,
                'special location': item.s_special_hanlding_code,
                'created': item.t_created 
            }
            return formatted;
        });
        fileDownload(formatted, `Coolers Data ${moment().format('YYYY-MM-DD')}.csv`);
    }

    return (
        <div>
            <ActionIcon type="print" onClick={exportData} />
            <VirtualTable
                data={sortedData || []}
                mapping={[{
                    name: 'Location',
                    value: 'location',
                    customWidth: 100
                }, {
                    name: 'Setting °C',
                    value: 'setting',
                    number: true,
                    customWidth: 100
                }, {
                    name: 'Current °C',
                    value: 'tempVal',
                    number: true,
                    customWidth: 100
                }, {
                    name: 'MAWB',
                    value: 's_mawb',
                    s_mawb: true
                }, {
                    name: 'Pieces',
                    value: 'i_pieces',
                    number: true,
                    smallWidth: true
                }, {
                    name: 'Destination',
                    value: 's_destination',
                    smallWidth: true
                }, {
                    name: 'SHC',
                    value: 's_special_hanlding_code'
                }]}
                reactTableRef={tableRef}
            />
        </div>
    );
}